import styled from 'styled-components';

type PropsType = {
  $zIndex: number;
};

const InvisibleBackdrop = styled.div<PropsType>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex};
  width: 100%;
  height: 100%;
`;

export default InvisibleBackdrop;
